function TriggerModalController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.triggers = ctrl.resolve.triggers;
  };

  ctrl.selectTrigger = ($event, trigger) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedTrigger === trigger) {
      ctrl.selectedTrigger = null;
    } else {
      ctrl.selectedTrigger = trigger;
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.selectedTrigger });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('TriggerModalController', TriggerModalController);
